module.exports = __webpack_public_path__ + "static/media/JenisPelitupMuka.dc85295d.jpg";